import React from 'react';
import Icon from '@/v1/components/atoms/Icon';

import './HotspotSmall.scss';

const HotspotSmall = (props) => (
    <Icon iconName="HotspotSmall" {...props}>
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <path d="M8 1a7 7 0 11-7 7 7 7 0 017-7m0-1a8 8 0 108 8 8 8 0 00-8-8z" />
            <path className="HotspotSmall__plus" d="M8.5 7.5v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z" />
        </svg>
    </Icon>
);

export default HotspotSmall;
